import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiLogin, apiLogout, apiMe, apiRegister } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await apiMe();
      setUser(me);
    } catch (e) {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  const login = async (email, password) => {
    const u = await apiLogin({ email, password });
    setUser(u);
    return u;
  };

  const register = async (payload) => {
    const u = await apiRegister(payload);
    setUser(u);
    return u;
  };

  const logout = async () => {
    try { await apiLogout(); } catch (e) { /* ignore */ }
    setUser(null);
  };

  const isApproved = !!user && (user.role === "admin" || user.is_approved === true);
  const isAdmin = !!user && user.role === "admin";

  return (
    <AuthContext.Provider value={{ user, loading, isApproved, isAdmin, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
